import { Link } from 'react-router-dom';

import { BUSINESS_DISPLAY, hasReportedEcommerceNumber } from '../../config/business';
import { POLICY_LAST_UPDATED } from '../../config/compliance';
import { SITE_CONFIG } from '../../config/site';

const serviceLinks = [
  { to: '/origins', label: '서비스 소개' },
  { to: '/archives', label: '이용안내' },
  { to: '/business-info', label: '사업자 정보' },
  { to: '/contact', label: '문의' },
] as const;

const policyLinks = [
  { to: '/terms', label: '이용약관' },
  { to: '/privacy', label: '개인정보처리방침' },
  { to: '/refund', label: '환불정책' },
  { to: '/credits', label: '제작 정보' },
] as const;

const businessInfoLines = [
  `상호: ${BUSINESS_DISPLAY.companyName}`,
  `대표자: ${BUSINESS_DISPLAY.ceoName}`,
  `사업자등록번호: ${BUSINESS_DISPLAY.businessNumber}`,
  `주소: ${BUSINESS_DISPLAY.address}`,
  `대표번호: ${BUSINESS_DISPLAY.phone}`,
  `이메일: ${BUSINESS_DISPLAY.email}`,
  `호스팅 서비스: ${BUSINESS_DISPLAY.hostingProvider}`,
];

if (hasReportedEcommerceNumber) {
  businessInfoLines.splice(3, 0, `통신판매업 신고번호: ${BUSINESS_DISPLAY.ecommerceNumber}`);
}

const linkClassName =
  'text-xs text-[#c9b18d] transition-colors hover:text-[#f7e7c6]';

export function GlobalFooter() {
  return (
    <footer className="border-t border-[#2b2018] bg-[linear-gradient(180deg,rgba(19,14,12,0.96),rgba(11,9,8,0.98))] px-4 py-6 text-[#ceb693] sm:px-6 lg:px-10">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-4">
        <nav className="flex flex-wrap gap-x-4 gap-y-2">
          {[...serviceLinks, ...policyLinks].map((link) => (
            <Link key={link.to} className={linkClassName} to={link.to}>
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="space-y-2 border-t border-[#2f251d] pt-4">
          <p className="text-sm font-semibold text-[#ead9be]">{BUSINESS_DISPLAY.companyName}</p>
          <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs leading-6 text-[#ae9168]">
            {businessInfoLines.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </div>
          <p className="text-[11px] leading-5 text-[#8f7249]">
            {SITE_CONFIG.serviceNameEn} | Updated {POLICY_LAST_UPDATED}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default GlobalFooter;
